export default __webpack_public_path__ + "48940d28496c1a636afed706f9edc659.png";